<template>
    <div class="right-bar" v-if="pageModel.id">
        <div class="bar-tabs">
            <h5 class="tw-text-base" @click="activateTab('settings')" :class="activeTab === 'settings'?'active':''">Settings</h5>
            <h5 class="tw-text-base" @click="activateTab('theme')" :class="activeTab === 'theme'?'active':''">Theme</h5>
        </div>
        
        <form v-if="activeTab === 'settings'" class="survey-question-settings-form large-form seamless">
            <div class="form-line">
                <div class="form-field" id="form-field-question-type">
                    <label>Survey Page Type</label>
                    <WSSelect class="question-type-select" v-model="pageModel.question_type" :options="questionTypes" @input="onUpdatePageType" />
                </div>
            </div>

            <div v-if="questionModel.id" class="form-line">
                <div class="form-field form-field-checkbox" id="form-field-required">
                    <label>Required To Answer</label>
                    <WSSwitch v-model="questionModel.required" @input="onUpdateQuestion" no-label="Not Required" yes-label="Answer Reqired" />
                </div>
            </div>

            <div v-if="['ranking','single-choice','multiple-choice'].includes(questionModel.type)" class="form-line">
                <div class="form-field form-field-checkbox" id="form-field-required">
                    <label>Vertical Alignment</label>
                    <WSSwitch v-model="questionModel.vertical" @input="onUpdateQuestion" no-label="Show in line" yes-label="Align Vertically" />
                </div>
            </div>

            <div v-if="['single-choice','multiple-choice'].includes(questionModel.type)" class="form-line">
                <div class="form-field form-field-checkbox" id="form-field-required">
                    <label>Other Option</label>
                    <WSSwitch v-model="questionModel.other_option" @input="onUpdateQuestion" no-label='"Other" Hidden' yes-label='"Other" Enabled' />
                </div>
            </div>

            <div v-if="['opinion-scale'].includes(questionModel.type)" class="form-line">
                <div class="form-field" id="form-field-select-page" style="width: calc(50% - 10px); margin-right: 20px">
                    <label>Min Value</label>
                    <WSSelect v-model="questionModel.start_from_zero" :options="[0,1]" direct @input="onUpdateQuestion" />
                </div>
                <div class="form-field" id="form-field-select-page" style="width: calc(50% - 10px)">
                    <label>Max Value</label>
                    <WSSelect v-model="questionModel.max_value" :options="[5,6,7,8,9,10]" direct @input="onUpdateQuestion" />
                </div>
            </div>

            <div v-if="['rating'].includes(questionModel.type)"
                 class="form-line tw-w-ful tw-text-left tw-items-center tw-gap-2 tw-mb-3 tw-whitespace-nowrap">
                <div class="form-field" id="form-field-select-page" style="width: 50%">
                    <label>No of Stars</label>
                    <WSSelect v-model="questionModel.max_value" :options="[3,4,5,6,7,8,9,10]" direct @input="onUpdateQuestion" />
                </div>
            </div>
            <div v-if="['boolean'].includes(questionModel.type)" class="form-line tw-w-full tw-mb-3">
                <div class="form-field form-field-boolean">
                    <div class="tw-w-full tw-text-left">
                        <label>Yes Value</label>
                        <input class="tw-form-input" type="text" v-model="questionModel.yes_value" placeholder="Yes" @input="delayedUpdateQuestion">
                    </div>
                    <div class="tw-w-full tw-text-left">
                        <label>No Value</label>
                        <input class="tw-form-input" type="text" v-model="questionModel.no_value" placeholder="No" @input="delayedUpdateQuestion">
                    </div>
                </div>
            </div>

            <div v-if="['date'].includes(questionModel.type)" class="form-line">
                <div class="form-field" id="form-field-select-page" >
                    <label>Date Format</label>
                    <WSSelect v-model="questionModel.format" :options="['DDMMYYYY','MMDDYYYY','YYYYMMDD']" direct @input="onUpdateQuestion" />
                </div>
            </div>
            <div v-if="['date'].includes(questionModel.type)" class="form-line">
                <div class="form-field" id="form-field-select-page">
                    <label>Date Separator</label>
                    <WSSelect v-model="questionModel.separator" :options="['/','.','-']" direct @input="onUpdateQuestion" style="width: calc(50% - 10px)" />
                </div>
            </div>
            
        </form>

        <div v-if="activeTab === 'settings'" class="page-actions">
            <div v-if="pageModel.type==='final'" @click="openLogicModal" class="ws-button ws-button-main mt-2">Action on Complete</div>
            <div v-else @click="openLogicModal" class="ws-button mt-2">Page Logic Settings</div>
            <div @click="backgroundModal = true" class="ws-button ws-button-secondary mt-3">{{ page.background_image ? 'Change Background' : 'Add Background'}}</div>
        </div>
        
        <div v-if="activeTab === 'theme'" class="themes tw-flex tw-flex-grow tw-flex-col tw-gap-2 tw-overflow-auto tw-text-center">
            <div class="theme" v-for="theme in themes"
                 :key="theme.id" :class="{ 'active': theme.id === parent.theme_id }"
                 @click="selectTheme(theme)">
                <div class="theme-preview">
                    <page-view
                        :page="samplePage"
                        :styles="theme.styles"
                        :editable="false"
                        :readonly="true"
                        view="preview-theme-small"
                    />
                </div>
                <span class="name">{{ theme.name }}</span>
            </div>

            <div v-if="!themes.length" class="small-note" style="font-size: 13px; margin-bottom: 0">
                <b>Your theme library is empty.</b> Click below to add themes from our gallery or to create your own.
            </div>
        </div>
        <router-link v-if="activeTab === 'theme'" :to="{name: 'surveys-themes'}" class="ws-button tw-text-center mt-3">Manage Themes</router-link>

        <modal v-if="backgroundModal" @close="backgroundModal = false">
            <h3>Page Background Image</h3>
            <form class="large-form">
                <div class="form-line">
                    <div class="form-field" id="form-field-background" style="width: 100%;">
                        <label for="form-input-name">Background Image</label>
                        <media-gallery-selector v-model="pageModel.background_image"/>
                        <div class="field-note" v-if="!pageModel.background_image"><b>You can customise the background image</b> of any specific page by selecting an image from your media gallery or uploading new image.</div>
                    </div>
                </div>
            </form>
            <div class="form-actions">
                <div type="button" class="ws-button ws-button-secondary" @click="backgroundModal = false">Cancel</div>
                <div type="submit" class="ws-button ws-button-main" @click="onUpdatePage">Update Background Image</div>
            </div>
        </modal>

        <modal v-if="logicModal" @close="logicModal = false">
            <h3>{{ pageModel.type === 'final'?'Completed Survey Action':'Action Button Logic'}}</h3>
            <div class="large-form">
                <template v-if="pageModel.type !== 'question'">
                    <div class="form-line">
                        <div class="form-field" id="form-field-button-action">
                            <label for="form-input-button-action">Button Action</label>
                            <WSSelect v-if="pageModel.type === 'welcome'" v-model="pageModel.page_logic_type" :options="[
                                {value: 'next_page', text: 'Go To Next Page'},
                                {value: 'specific_page', text: 'Go To Specific Page'},
                            ]" @input="onUpdatePageAction" />
                            <WSSelect v-else-if="pageModel.type === 'context'" v-model="pageModel.page_logic_type" :options="[
                                {value: 'next_page', text: 'Go To Next Page'},
                                {value: 'specific_page', text: 'Go To Specific Page'},
                                {value: 'campaign', text: 'Invite To Campaign'},
                                {value: 'external_url', text: 'Go To External URL'},
                                {value: 'hide', text: 'Hide Action Button'}
                            ]" @input="onUpdatePageAction" />
                            <WSSelect v-else v-model="pageModel.page_logic_type" :options="[
                                {value: 'campaign', text: 'Invite To Campaign'},
                                {value: 'external_url', text: 'Go To External URL'},
                                {value: 'hide', text: 'Hide Action Button'}
                            ]" @input="onUpdatePageAction" />
                        </div>
                    </div>
                    <div v-if="pageModel.page_logic_type === 'specific_page'" class="form-line">
                        <div class="form-field" id="form-field-select-page">
                            <label for="form-input-select-page">Select Next Page</label>
                            <WSSelect v-model="pageModel.page_logic_value" :options="pages" text-attr="name" value-attr="id" />
                        </div>
                    </div>
                    <div v-if="pageModel.page_logic_type === 'campaign'" class="form-line">
                        <div class="form-field" id="form-field-select-campaign">
                            <label for="form-input-select-campaign">Select Campaign</label>
                            <WSSelect v-if="campaigns.length" v-model="pageModel.page_logic_value.campaign" :options="campaigns" text-attr="name" value-attr="id" />
                            <div v-else class="field-note">Fetching Campaigns...</div>
                        </div>
                    </div>
                    <div v-if="pageModel.page_logic_type === 'campaign'" class="form-line">
                        <div class="form-field" id="form-field-select-campaign">
                            <label for="form-input-select-campaign">Invitation Email Field</label>
                            <WSSelect v-if="emailQuestions.length" v-model="pageModel.page_logic_value.email_question" :options="emailQuestions" text-attr="name" value-attr="first_question_id" />
                            <div class="small-note" style="margin-top: 10px;" :class="{error: !emailQuestions.length}"><span v-if="!emailQuestions.length">You don't have any email questions in your survey.</span> All campaign invitations are identified primarily by their email, therefore you need to collect invitee email in the survey. </div>
                            <div v-if="!emailQuestions.length" class="ws-button ws-button-secondary small" style="float: left; margin-top: -5px;" @click="addEmailQuestionPage">Create Email Question Page</div>
                        </div>
                    </div>
                    <div v-if="pageModel.page_logic_type === 'external_url'" class="form-line">
                        <div class="form-field" id="form-field-external-url">
                            <label for="form-input-external-url">External URL</label>
                            <input id="form-input-external-url" type="url" v-model="pageModel.page_logic_value" />
                        </div>
                    </div>
                </template>
                <template v-if="pageModel.type==='question'">
                    <div class="form-line">
                        <div class="form-field" id="form-field-page-logic">
                            <label for="form-input-page-logic">Page Logic</label>
                            <WSSelect v-model="pageModel.page_logic_type" @input="onQuestionLogicTypeChange" :options="[
                                {value: 'next_page', text: 'Go To Next Page'},
                                {value: 'dynamic', text: 'Custom Advanced Logic'}
                            ]" />
                            <div class="field-note" v-if="pageModel.page_logic_type==='next_page'">Page action button simply leads to the next survey pageModel.</div>
                            <div class="field-note" v-if="pageModel.page_logic_type==='dynamic'">Allows you to set custom rules to where does the page action button leads based on answers to questions on this pageModel.</div>
                        </div>
                    </div>
                    <div v-if="pageModel.page_logic_type === 'dynamic'" class="form-line">
                        <div class="form-field form-field-dynamic-logic">
                            <page-logic-form v-for="(rule, index) in pageModel.logic_rules"
                                             :key="index"
                                             :rule="rule"
                                             :questions="pageModel.questions"
                                             :pages="pages"
                                             @change="onUpdateLogicRule(index, $event)"
                                             @remove="onRemoveLogicRule(index)"/>
                            <div class="ws-button small" style="float: left" @click="onAddLogicRule">Add Rule</div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="form-actions">
                <div type="button" class="ws-button ws-button-secondary" @click="logicModal = false">Cancel</div>
                <div type="submit" class="ws-button ws-button-main" @click="onUpdatePage">Save Page Logic</div>
            </div>
        </modal>
        
    </div>
</template>

<script>
import PageView from "@/pages/surveys/PageView.vue";
import WSSelect from "@/components/elements/WSSelect.vue";
import WSSwitch from "@/components/elements/WSSwitch.vue";
import MediaGallerySelector from "@/components/MediaGallerySelector.vue";
import Modal from "@/components/modals/Modal.vue";
import PageLogicForm from "@/pages/surveys/PageLogicForm.vue";
import {debounce} from "lodash-es";

export default {
    name: "SurveySettingsBar.vue",
    components: {PageLogicForm, Modal, MediaGallerySelector, WSSwitch, WSSelect, PageView},
    data() {
        return {
            pageModel: {
                id: undefined,
                name: undefined,
                title: undefined,
                display_title: false,
                page_logic_type: 'next_page',
                page_logic_value: undefined,
                type: 'question',
                question_type: '',
                logic_rules: [],
                button_text: '',
                order: 0,
            },
            questionModel: {
                name: '',
                id: undefined,
                type: undefined,
                start_from_zero: undefined,
                max_value: undefined,
                yes_value: undefined,
                no_value: undefined,
                vertical: true,
            },
            activeTab: 'settings',
            backgroundModal: false,
            logicModal: false,
            questionTypes: [
                { value: 'context-rating', text: 'Rating & Ranking', isContext: true},
                { value: 'opinion-scale', text: 'Opinion scale' },
                { value: 'rating', text: 'Rating' },
                { value: 'ranking', text: 'Ranking' },

                { value: 'context-text', text: 'Text & Contact Info', isContext: true},
                { value: 'email', text: 'Email' },
                { value: 'phone-number', text: 'Phone number' },
                { value: 'website', text: 'Website' },
                { value: 'short-text', text: 'Short text' },
                { value: 'long-text', text: 'Long text' },
                { value: 'number', text: 'Number' },

                { value: 'context-choice', text: 'Single & Multiple Choice', isContext: true},
                { value: 'single-choice', text: 'Single choice' },
                { value: 'multiple-choice', text: 'Multiple choice' },
                { value: 'boolean', text: 'Boolean' },
                { value: 'date', text: 'Date' },

                { value: 'context-context', text: 'Static & Context Pages', isContext: true},
                { value: 'welcome', text: 'Welcome Page' },
                { value: 'context', text: 'Statement Page' },
                { value: 'final', text: 'Final Page' },
            ],
        }
    },
    props: {
        parent: {
            type: Object,
            required: true
        },
        storePrefix: {
            type: String,
            default: 'survey'
        },
    },
    computed: {
        campaigns() {
            return this.$store.state.giftBoxCampaign.index.data;
        },
        pages() {
            return this.$store.getters[`${this.storePrefix}Pages/orderedList`];
        },
        samplePage() {
            return this.$store.state.surveyThemeSamplePageSmall;
        },
        themes() {
            if (this.storePrefix === 'survey') return this.$store.getters["surveyThemes/orderedList"];
            else return this.$store.getters["surveyThemesGallery/orderedList"];
        },
        page() {
            return this.$store.getters[`${this.storePrefix}Pages/selected`] || {};
        },
        question() {
            return this.$store.getters[`${this.storePrefix}Questions/selected`] || {};
        },
        emailQuestions() {
            return this.pages.filter(page => page.question_type === 'email');
        }
    },
    watch: {
        'page.id'() {
            this.resetPageModel();
        },
        question: {
            handler() {
                this.resetQuestionModel();
            },
            deep: true
        },
    },
    created() {
        this.resetPageModel();
        this.resetQuestionModel();
    },
    mounted() {
        this.delayedUpdateQuestion = debounce(event => {
            this.onUpdateQuestion(event);
        }, 1000);
    },
    methods: {
        activateTab(tab) {
            this.activeTab = tab;
        },
        async selectTheme({ id }) {
            if (this.storePrefix === 'survey') {
                this.$store.commit('surveyThemes/setSelected', id)
                await this.$store.dispatch('surveys/update', { id: this.parent.id, theme_id: id });
            } else {
                this.$store.commit('surveyThemesGallery/setSelected', id)
                await this.$store.dispatch('surveyTemplates/update', {id: this.parent.id, theme_id: id});
            }
        },
        async onUpdateQuestion() {
            await this.$store.dispatch(`${this.storePrefix}Questions/update`, this.questionModel);
            this.resetQuestionModel();
        },
        async onUpdatePage() {
            await this.$store.dispatch(`${this.storePrefix}Pages/update`, this.pageModel);
            this.resetPageModel();
            this.backgroundModal = false;
            this.logicModal = false;
        },
        async onUpdatePageType() { // Dynamically changing the existing page / question type
            let pageTypeLabel = this.questionTypes.filter(type => type.value === this.pageModel.question_type)[0].text;
            
            this.pageModel.type = this.pageModel.question_type;
            this.pageModel.page_logic_type = 'next_page';
            
            if (['welcome','context','final'].includes(this.pageModel.question_type)) {
                if (this.pageModel.question_type === 'welcome')  {
                    this.pageModel.name = 'Welcome';
                    this.pageModel.page_logic_type = 'next_page';
                } else if (this.pageModel.question_type === 'context')  {
                    this.pageModel.name = 'Statement';
                }
                else if (this.pageModel.question_type === 'final')  {
                    this.pageModel.name = 'End Page';
                    this.pageModel.page_logic_type = 'hide';
                }
            }
            else {
                this.pageModel.type = 'question';
                this.pageModel.name = pageTypeLabel;
                if (!['next_page','dynamic'].includes(this.pageModel.page_logic_type)) this.pageModel.page_logic_type = 'next_page';
            }

            if (this.pageModel.type === 'question') {
                this.questionModel.type = this.pageModel.question_type;
                switch (this.questionModel.type) {
                    case "opinion-scale":
                        this.questionModel.start_from_zero = 1;
                        this.questionModel.max_value = 10;
                        break;
                    case "rating":
                        this.questionModel.max_value = 5;
                        break;
                    case "single-choice":
                    case "multiple-choice":
                    case "ranking":
                        if (!this.questionModel.options.length) this.questionModel.options = ['', '', ''];
                        break;
                }
                if (this.questionModel.id) {
                    await this.$store.dispatch(`${this.storePrefix}Questions/update`, this.questionModel);
                } else {
                    this.questionModel.name = '';
                    this.questionModel.page_id = this.pageModel.id;
                    let newQuestion = await this.$store.dispatch(`${this.storePrefix}Questions/create`, this.questionModel);
                    this.$store.commit(`${this.storePrefix}Questions/setSelected`, newQuestion.id);
                }
            } else {
                this.$store.commit(`${this.storePrefix}Questions/setSelected`, null);
            }

            await this.$store.dispatch(
                `${this.storePrefix}Pages/update`, 
                {...this.pageModel, ... (this.pageModel.type !== 'question'? {'delete_all_questions':true}:{})}
            );
            this.resetPageModel();
            this.resetQuestionModel();
        },
        async onUpdatePageAction() {
            this.pageModel.page_logic_value = null;
            if (this.pageModel.page_logic_type === 'campaign') {
                this.pageModel.page_logic_value = {campaign: null, email_question: ''}
                await this.dispatchWaitAndNotify('fetchGiftBoxCampaigns', null, false, true);
            }
        },
        async openLogicModal() {
            this.logicModal = true;
            await this.dispatchWaitAndNotify('fetchGiftBoxCampaigns', null, false, true);
        },
        onQuestionLogicTypeChange(type) {
            if (type === 'dynamic' && !this.pageModel.logic_rules) {
                this.onAddLogicRule();
            }
        },
        onAddLogicRule() {
            if (!this.pageModel.logic_rules) {
                this.$set(this.pageModel, 'logic_rules', []);
            }

            this.pageModel.logic_rules.push({
                question: this.pageModel.questions[0].id,
                operation: '',
                value: '',
                page: ''
            })
        },
        onUpdateLogicRule(index, data) {
            this.pageModel.logic_rules.splice(index, 1, data);
        },
        onRemoveLogicRule(index) {
            this.pageModel.logic_rules.splice(index, 1);
        },
        async addEmailQuestionPage() {
            this.logicModal = false;
            
            let emailPage = {
                name: 'Email',
                type: 'question',
                order: this.pageModel.order,
                question: {
                    type: 'email',
                    name: 'What is your email address?',
                    required: true,
                }
            }
            console.log(emailPage);
            const page = await this.$store.dispatch('surveyPages/create', emailPage);
            
            this.pageModel.order++;
            console.log(this.pageModel);
            await this.$store.dispatch(`${this.storePrefix}Pages/update`, {id: this.pageModel.id, order: this.pageModel.order});

            await this.$store.dispatch('surveyPages/getList', emailPage);
            await this.$parent.selectPage(page);
        },
        resetPageModel() {
            this.pageModel = { ...this.page };
        },
        resetQuestionModel() {
            this.questionModel = { ...this.question };
            if (!this.questionModel.options) {
                this.$set(this.questionModel, 'options', []);
            }
        }
    }
}
</script>

<style scoped>

</style>